module.exports = __webpack_public_path__ + "img/logo.8ab12c6b.svg";